import ApiService from "../api.services";

const NotificationService = {
  add: async function (to, subject, messageHtml, messageText, highlight) {
    try {
      const data = {
        to, subject, messageText, messageHtml, highlight
      }
      const response = await ApiService.post(`/api/notification`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  tag: async function (tag) {
    try {
      const response = await ApiService.get(`/api/notification/tag/phone/${tag}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  deleteTag: async function (id) {
    try {
      const response = await ApiService.delete(`/api/notification/tag/phone/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  logs: async function (tag, phone) {
    try {
      const data = {
        tag, phone,
      }
      const response = await ApiService.post(`/api/notification/tag/phone`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  notification: async function (tag, phone) {
    try {
      const response = await ApiService.post(`/api/notification/tag/phone/${tag}`, {
        phone: phone,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  phone: async function (id) {
    try {
      const response = await ApiService.delete(`/api/notification/tag/phone/${tag}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  list: async function (records, page, read, highlight) {
    try {
      const response = await ApiService.get(`/api/notification/message/list?records=${records}&offset=${page}&read=${read}&highlight=${highlight}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  count: async function (read) {
    try {
      const response = await ApiService.get(`/api/notification/message/list/count?type=${read}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  read: async function (id, read) {
    try {
      const response = await ApiService.patch(`/api/notification/message/save?read=${read}`, {
        list: id
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  delete: async function (id) {
    try {
      const response = await ApiService.post(`/api/notification/message/delete`, {
        list: id
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default NotificationService;

export { NotificationService };
